import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const reviews = [{
    text: 'Nach zwei Wochen hatte unser Hund keine Beschwerden mehr. So einfach.',
    author: 'Thomas aus Hamburg'
  }, {
    text: 'Viele Jahre viel Geld ausgegeben. Nichts hat geholfen. Um so überraschter war ich, als schon nach 14 Tagen Besserung eintrat. Heute geht es unserer Lotta so gut wie nie.',
    author: 'Martina aus München'
  }, {
    text: 'Endlich ein Zusatz, der wirklich wirkt. Meine Hündin ist sichtbar fitter, aktiver, wacher – ohne Verdauungsprobleme.',
    author: 'Nadja & Sonnenblume'
  }];
  return <section className="py-16 bg-cardBg" data-id="element-87">
      <div className="max-w-5xl mx-auto px-4" data-id="element-88">
        <h2 className="font-handwritten text-4xl text-center text-forestGreen mb-12" data-id="element-89">
          Das sagen andere Hundeeltern
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-90">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-cream p-8 rounded-xl shadow-md border border-warmBrown/10 flex flex-col h-full" data-id="element-91">
              <div className="flex gap-1 mb-4" data-id="element-92">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-warmBrown text-warmBrown" data-id="element-93" />)}
              </div>
              <p className="font-serif text-gray-800 italic mb-6 flex-grow" data-id="element-94">
                "{review.text}"
              </p>
              <p className="font-serif font-bold text-forestGreen" data-id="element-95">
                – {review.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}